/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1LocationCountriesCountryidLangsQueryResponse,
  GetApiV1LocationCountriesCountryidLangsPathParams,
  GetApiV1LocationCountriesCountryidLangs401,
  GetApiV1LocationCountriesCountryidLangs500,
} from "../../types/locationCountryLangController/GetApiV1LocationCountriesCountryidLangs.ts";

function getGetApiV1LocationCountriesCountryidLangsUrl(
  countryId: GetApiV1LocationCountriesCountryidLangsPathParams["countryId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/location/countries/${countryId}/langs` as const,
  };
  return res;
}

/**
 * @description Retorna todas as traduções (idiomas) cadastradas para o país informado. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas do país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:countryId/langs}
 */
export async function getApiV1LocationCountriesCountryidLangs(
  countryId: GetApiV1LocationCountriesCountryidLangsPathParams["countryId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1LocationCountriesCountryidLangsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1LocationCountriesCountryidLangs401
      | GetApiV1LocationCountriesCountryidLangs500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1LocationCountriesCountryidLangsUrl(
      countryId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
